<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-dolly-flatbed" /> Compras
        </h2>
        <small class="text-muted">Controle as compras de sua empresa.</small>
      </div>
    </div>
    <hr />
    <div class="form-group">
      <label>Arquivo Xml:</label>
      <input
        ref="fileInput"
        type="file"
        accept=".xml"
        class="form-control-file"
        @change="onFileSelected"
      />
    </div>
    <b-alert :show="xmlError" fade variant="danger" @dismissed="xmlError = false" dismissible>
      Erro ao ler o arquivo.
    </b-alert>
    <hr />

    <h5 class="text-primary d-inline"><i class="fas fa-user" /> Fornecedor</h5>
    <div class="row mt-4 mb-4">
      <div class="col-md-4">
        <person-select v-model="form.vendor" person-type="v" />
      </div>
      <div class="offset-md-4 col-md-2">
        <text-input v-model="form.number" :alias="'Número da Nota'" />
        <text-input  type="date" v-model="form.emited_at"  :alias="'Data de emissão'" />
        <text-input type="date"  v-model="form.entry_at" :alias="'Data de entrada'" />
      </div>
      <div class="col-md-2">
        <text-input v-model="form.serie" :alias="'Série'" />
        <text-input v-model="form.mod" :alias="'Modelo'" />
        
        <!-- <text-input v-model="form.mod" :alias="'Operação ???'"/> -->
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-5">
              <h5 class="text-primary d-inline mb-2">
                <i class="fas fa-boxes" /> Produtos
              </h5>
            </div>
            <purchase-product-form
              ref="purchaseProductForm"
              @input="handlePurchaseProductInput($event)"
            />
            <div class="row mt-4 mb-4">
              <div class="col-md-12">
                <!-- {{ this.form.purchase_products }} -->
                <purchase-product-list
                  :purchase-products="form.purchase_products"
                  @edit="handleEditPurchaseProduct($event)"
                  @delete="handleDeletePurchaseProduct($event)"
                  @linkProduct="handleLinkProduct($event)"
                  @editProduct="handleEditProduct($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div>
              <h5 class="text-primary"><i class="fas fa-equals"></i> Totais</h5>
            </div>
            <div class="row">
              <div class="offset-8 col-md-2 text-right">
                <b>Total dos produtos</b>
                <br />
                <b>{{ totals.product_total | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <b>Total da compra</b>
                <br />
                <b>{{ totals.net_total | decimal }}</b>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-2 text-right">
                <small>Base Calc. Icms</small>
                <br />
                <b>{{ totals.icms_calc_base | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>Icms</small>
                <br />
                <b>{{ totals.icms | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>Base Calc. Icms St. </small>
                <br />
                <b>{{ totals.icms_st_calc_base | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>Icms St. </small>
                <br />
                <b>{{ totals.icms_st | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>B. C. IPI </small>
                <br />
                <b>{{ totals.ipi_calc_base | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>IPI </small>
                <br />
                <b>{{ totals.ipi | decimal }}</b>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 text-right">
                <small>Seguro</small>
                <br />
                <b>{{ totals.insurance | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>Frete</small>
                <br />
                <b>{{ totals.shipping | decimal }}</b>
              </div>
              <div class="col-md-2 text-right">
                <small>Outras Desp. </small>
                <br />
                <b>{{ totals.expenses | decimal }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="text-primary">
              <i class="fas fa-file-invoice-dollar"></i> Pagamentos
            </h5>
            <purchase-bill-form v-model="form.purchase_bills" />
          </div>
        </div>
      </div>
    </div>
    <error-handler :error="error" />
    <!-- <hr /> -->
    <div class="row text-right">
      <div class="col-md-12">
        <button class="btn btn-primary mr-2" @click="handleStore('d')">
          Salvar Rascunho
        </button>

         <button class="btn btn-success" @click="handleStore('p')">
          Confirmar Compra
        </button>
      </div>
    </div>
    <link-product-form
      ref="linkProductForm"
      @input="handleLinkedProduct($event)"
    />
    <ProductForm ref="ProductForm" @stored="updateProductData($event)" />
  </div>
</template>

<script>
import ProductForm from "@/components/product/forms/ProductForm";
import PersonSelect from "@/components/person/inputs/PersonSelect";
import PurchaseProductForm from "@/components/purchase/forms/PurchaseProductForm";
import LinkProductForm from "@/components/purchase/forms/LinkProductForm";
import PurchaseBillForm from "@/components/purchase/forms/PurchaseBillForm";
import PurchaseProductList from "@/components/purchase/sections/PurchaseProductList";
import moment from 'moment'
export default {
  components: {
    ProductForm,
    PersonSelect,
    PurchaseProductForm,
    LinkProductForm,
    PurchaseBillForm,
    PurchaseProductList,
  },

  data: () => ({
    xml: null,

    form: {
      vendor: null,
      number: null,
      serie: null,
      mod: null,
      emited_at: null,
      entry_at: null,
      chave_nfe: null,
      // addition: null,
      // discount: null,
      // shipping: null,
      // net_total: null,
      // notes: null,
      purchase_products: [],
      purchase_bills: [],
    },

    error : null,
    xmlError : null,

    editProductIndex: null,
  }),

  async mounted() {
    if (this.$route.params.id) {
      let data = await this.$store.dispatch(
        "purchase/getPurchase",
        this.$route.params.id
      );

      this.form = data.purchase;
      this.form.emited_at  = moment( data.purchase.emited_at).format("YYYY-MM-DD")
      this.form.entry_at  = moment(data.purchase.entry_at).format("YYYY-MM-DD")
    }

    this.$store.commit("pageHasLoaded");
  },

  computed: {
    totals() {
      let totals = {
        product_total: 0,
        icms_calc_base: 0,
        icms_aliquot: 0,
        icms: 0,
        icms_st_calc_base: 0,
        icms_st_aliquot: 0,
        icms_st: 0,
        ipi_calc_base: 0,
        ipi_aliquot: 0,
        ipi: 0,
        discount : 0,
        shipping: 0,
        expenses: 0,
        insurance: 0,
        net_total: 0,

      };

      for (let index in this.form.purchase_products) {
        let product = this.form.purchase_products[index];
        totals.product_total += parseFloat(product.quantity) * parseFloat(product.price);
        totals.icms_calc_base += parseFloat(product.icms_calc_base);
        totals.icms_aliquot += parseFloat(product.icms_aliquot);
        totals.icms += parseFloat(product.icms);
        totals.icms_st_calc_base += parseFloat(product.icms_st_calc_base);
        totals.icms_st_aliquot += parseFloat(product.icms_st_aliquot);
        totals.icms_st += parseFloat(product.icms_st);
        totals.ipi_calc_base += parseFloat(product.ipi_calc_base);
        totals.ipi_aliquot += parseFloat(product.ipi_aliquot);
        totals.ipi += parseFloat(product.ipi);
        totals.discount += parseFloat(product.discount);
        totals.shipping += parseFloat(product.shipping);
        totals.expenses += parseFloat(product.expenses);
        totals.insurance += parseFloat(product.insurance);
      }

      totals.net_total +=
        totals.product_total -
        totals.discount +
        totals.icms_st +
        totals.ipi +
        totals.shipping +
        totals.expenses +
        totals.insurance;

      return totals;
    },
  },

  methods: {
    handleEditProduct({ product_base_id, product_index }) {
      this.editProductIndex = product_index;
      this.$refs.ProductForm.open(product_base_id);
    },

    updateProductData(product_base) {
      let product = this.form.purchase_products[this.editProductIndex];

      product.product_base = product_base;

      this.$set(this.form.purchase_products, this.editProductIndex, product);
      this.editProductIndex = null;
    },

    onFileSelected(event) {
      this.xml = event.target.files[0];

      this.parseXml();
    },

    async parseXml() {
      this.xmlError = null
      let form = new FormData();

      form.append("xml", this.xml, "xml");
      
      this.$store.commit("showLoading");
      await this.$store
        .dispatch("purchase/getParsedXml", form)
        .then((response) => {
          this.form = response.data;
        })
        .catch((error) => {
          this.xmlError = true
        });
        this.$store.commit("hideLoading");
    },

    handlePurchaseProductInput(purchaseProduct) {
      if (this.editProductIndex == null) {
        this.addProduct(purchaseProduct);
      } else {
        this.updateProduct(purchaseProduct);
      }
    },

    addProduct(purchaseProduct) {
      this.form.purchase_products.push(purchaseProduct);
    },

    updateProduct(purchaseProduct) {
      this.$set(
        this.form.purchase_products,
        this.editProductIndex,
        purchaseProduct
      );
      this.editProductIndex = null;
    },

    handleEditPurchaseProduct(index) {
      this.editProductIndex = index;
      this.$refs.purchaseProductForm.setPurchaseProduct(
        this.form.purchase_products[index]
      );
      //this.$delete(this.form.purchase_products, index);
    },

    handleDeletePurchaseProduct(index) {
      this.$delete(this.form.purchase_products, index);
    },

    async handleStore(saveAs) {
      this.$store.commit("showLoading");
      
      this.form.save_as = saveAs

      await this.$store.dispatch("purchase/postPurchase", this.form).then(response => {
        this.$router.push('/compras')
      }).catch(error => {
        this.error = error
      })

      this.$store.commit("hideLoading");


    },

    handleLinkProduct(index) {
      this.editProductIndex = index; // todo reset if cancel form

      let product = JSON.parse(
        JSON.stringify(this.form.purchase_products[index])
      );

      this.$refs.linkProductForm.open(product);
    },

    handleLinkedProduct(product) {
      this.$set(this.form.purchase_products, this.editProductIndex, product);

      this.editProductIndex = null;
    },
  },
};
</script>

<style>
</style>